import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { selectDecisionEngineAsDefault } from 'lib/api/decisionEngine';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { errorHandler } from 'lib/functions/errors';
import { showAlert } from 'lib/functions/utils';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { DecisionEngine } from '../../../Show';

type Props = {
  selectedEngine: DecisionEngine | null;
  openDefault: boolean;
  setOpenDefault: (open: boolean) => void;
  setUp: () => Promise<void>;
};

const DefaultDecisionEngineDialog = (props: Props) => {
  const { selectedEngine, openDefault, setOpenDefault, setUp } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const confirmDefault = async () => {
    try {
      if (!selectedEngine) return;
      setLoading(true);
      await selectDecisionEngineAsDefault(dispatch, selectedEngine.id);
      setOpenDefault(false);
      showAlert(dispatch, 'success', 'Motor seleccionado como predeterminado');
      await setUp();
    } catch (error) {
      errorHandler(
        dispatch,
        error,
        'Error al seleccionar motor como predeterminado',
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={openDefault} onClose={() => setOpenDefault(false)}>
      <DialogTitle>Seleccionar motor</DialogTitle>
      {loading ? (
        <CenteredCircularProgress type="dialog" />
      ) : (
        <DialogContent>
          <Typography>
            Para todas las decisiones de{' '}
            <b>{selectedEngine?.revisionObjective}</b> se utilizará este motor
            como predeterminado.
          </Typography>
          <Typography>
            ¿Estás seguro de que deseas seleccionar el motor{' '}
            {selectedEngine?.name} como predeterminado?
          </Typography>
        </DialogContent>
      )}
      <DialogActions>
        <CustomButton onClick={() => setOpenDefault(false)} color="secondary">
          Cancelar
        </CustomButton>
        <CustomButton onClick={() => confirmDefault()} color="primary">
          Seleccionar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DefaultDecisionEngineDialog;
